export default __webpack_public_path__ + "static/media/location.9d2ccc38.svg";